import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type Theme = 'light' | 'dark'

function applyThemeClass(theme: Theme) {
  document.documentElement.classList.toggle('dark', theme === 'dark')
}

interface SettingsState {
  theme: Theme
  toggleTheme: () => void
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set, get) => ({
      theme: 'dark',
      toggleTheme: () => {
        const next = get().theme === 'dark' ? 'light' : 'dark'
        applyThemeClass(next)
        set({ theme: next })
      },
    }),
    {
      name: 'cap-settings',
      onRehydrateStorage: () => (state) => {
        if (state) applyThemeClass(state.theme)
      },
    },
  ),
)

// Apply synchronously on module load (before persisted state rehydrates) so the very first paint
// isn't dark-by-default when the user has light saved — onRehydrateStorage above corrects this
// once localStorage is actually read, a tick later.
applyThemeClass(useSettingsStore.getState().theme)
